// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PromoCollection_wrapper__hw_te"};